import styled from "styled-components";

export const WrapStyle = styled.div`
  padding: 4rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  border-radius: 3rem;
  background: ${({ theme }) => theme.color.background.white};

  ${({ theme }) => theme.media.small} {
    padding: 0;
    gap: 2rem;
    border-radius: 0;
  }
`;

export const TitleStyle = styled.h1`
  ${({ theme }) => theme.typography.h1.bold}
  letter-spacing: -0.072rem;

  ${({ theme }) => theme.media.small} {
    ${({ theme }) => theme.typography.t1.semibold}
  }
`;
